import { useEffect, useRef } from 'react';
import { useLocalizationContext } from '@im/react-localization';

import { usePreferredLanguageMutation } from './usePreferredLanguage';

export const usePreferredLanguageChange = (isAuthenticated: boolean) => {
  const { locale } = useLocalizationContext();
  const initialLocaleLanguage = useRef(locale);
  const preferredLanguageMutation = usePreferredLanguageMutation(locale);

  useEffect(() => {
    if (locale !== initialLocaleLanguage.current && isAuthenticated) {
      preferredLanguageMutation.mutate();
      initialLocaleLanguage.current = locale;
    }
  }, [locale, preferredLanguageMutation, isAuthenticated]);
};
